import { Popover, PopoverContent, PopoverTrigger } from "~/components/shared/PopoverNext";
import { TooltipLabelStyle, TooltipModel } from "chart.js";

const Title = ({ title }: { title: string }) => (
  <div className="text-charcoal-700 w-full border-b-2 border-gray-100 px-4 py-2">
    <h5 className="m-0">{title}</h5>
  </div>
);

const BodyLine = ({ line, color }: { line: string; color: TooltipLabelStyle }) => {
  const [title, count] = line.split(":");
  return (
    <div
      className="border-l-4 p-2 text-left"
      style={{ borderLeftColor: color.borderColor as string }}
    >
      <p className="text-charcoal-300 m-0 font-medium">{title}</p>
      <p className="text-charcoal-900 m-0 text-sm font-medium">{count}</p>
    </div>
  );
};

type UsageTooltipProps = {
  tooltip: TooltipModel<"line"> | TooltipModel<"bar"> | TooltipModel<"doughnut">;
};

const Body = ({ tooltip: { body, labelColors } }: UsageTooltipProps) => (
  <div className="space-y-1 p-2">
    {body.map((bodyLine, idx) => {
      return <BodyLine key={bodyLine.lines[0]} line={bodyLine.lines[0]} color={labelColors[idx]} />;
    })}
  </div>
);

const UsageTooltip = ({ tooltip }: UsageTooltipProps) => (
  <Popover open={true}>
    <PopoverTrigger />
    <PopoverContent className="shadow-depth-100 w-auto min-w-[200px] rounded-md border border-gray-100 bg-white p-0">
      <Title title={tooltip.title[0]} />
      <Body tooltip={tooltip} />
    </PopoverContent>
  </Popover>
);

export default UsageTooltip;
